module.exports = "./img/desktop_logo.c78dcd9.png";